export default __webpack_public_path__ + "static/media/owner1.0fd096e7.jpeg";